import { render, staticRenderFns } from "./TutorCourse.vue?vue&type=template&id=2624469f&"
import script from "./TutorCourse.vue?vue&type=script&lang=js&"
export * from "./TutorCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports